// extracted by mini-css-extract-plugin
export default {"container":"AdminSummaryDashboard_container__JZyzj"};